import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import "./c61_grey_title_content.scss";
import {insertHtml} from "../../utils/dom";

interface C61GreyTitleContentData {
    title?: string;
    content: string;
}

class C61GreyTitleContent extends TemplateComponent<C61GreyTitleContentData, TemplateComponentProps<C61GreyTitleContentData>> {

    componentRender(data: C61GreyTitleContentData): React.ReactElement<any> {

        if (!data || !data.content) {
            console.warn("WARNING: Cannot display component 61: missing field content from the API");
            return <div />;
        }

        return (
            <div className="c61-grey-title-content auto-margins">
                {data.title &&
                    <h3 className="title">{data.title}</h3>
                }
                <div className="content editor-html" {...insertHtml(data.content)} />
            </div>
        )
    }
}

export default C61GreyTitleContent;